// RetroFam Blog Template JavaScript - Simplified Version
class RetroFamBlogTemplate {
  constructor() {
    this.currentCategory = 'all';
    this.currentSearch = '';
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Category filter clicks
    const categoryFilters = document.getElementById('retrofamCategoryFilters');
    if (categoryFilters) {
      categoryFilters.addEventListener('click', (e) => {
        if (e.target.classList.contains('retrofam-category-filter')) {
          const category = e.target.dataset.category;
          this.setActiveCategory(category);
          this.filterBlogs();
        }
      });
    }

    // Search input
    const searchInput = document.getElementById('retrofamSearchInput');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.currentSearch = e.target.value.toLowerCase();
        this.filterBlogs();
      });
      
      // Search expansion functionality
      searchInput.addEventListener('focus', () => {
        searchInput.parentElement.classList.add('expanded');
      });
      
      searchInput.addEventListener('blur', () => {
        if (searchInput.value.trim() === '') {
          searchInput.parentElement.classList.remove('expanded');
        }
      });
      
      searchInput.addEventListener('input', () => {
        if (searchInput.value.trim() !== '') {
          searchInput.parentElement.classList.add('expanded');
        }
      });
    }
  }

  setActiveCategory(category) {
    this.currentCategory = category;
    
    document.querySelectorAll('.retrofam-category-filter').forEach(btn => {
      btn.classList.remove('active');
    });
    
    const activeBtn = document.querySelector(`[data-category="${category}"]`);
    if (activeBtn) {
      activeBtn.classList.add('active');
    }
  }

  filterBlogs() {
    const blogCards = document.querySelectorAll('.retrofam-blog-card');
    
    blogCards.forEach(card => {
      const title = card.querySelector('.retrofam-blog-title')?.textContent || '';
      const excerpt = card.querySelector('.retrofam-blog-excerpt')?.textContent || '';
      const tags = Array.from(card.querySelectorAll('.retrofam-blog-tag')).map(tag => tag.textContent.toLowerCase());
      
      const matchesCategory = this.currentCategory === 'all' || 
        tags.some(tag => tag === this.currentCategory);
      
      const matchesSearch = this.currentSearch === '' || 
        title.toLowerCase().includes(this.currentSearch) || 
        excerpt.toLowerCase().includes(this.currentSearch);
      
      if (matchesCategory && matchesSearch) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new RetroFamBlogTemplate();
}); 